import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Patients.css'; // Stil dosyasını oluşturacağız
import { toast } from 'react-toastify';

function Patients({ user }) {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false); // Düzenleme modu kontrolü
  const [currentId, setCurrentId] = useState(null); // Düzenlenen hastanın ID'si
  const [searchTerm, setSearchTerm] = useState(""); // Arama filtresi
  const [showDetailModal, setShowDetailModal] = useState(false); // Detay modalı
  const [selectedPatient, setSelectedPatient] = useState(null); // Seçili hasta
  const [sortOrder, setSortOrder] = useState('asc'); // Sıralama yönü
  const [currentPage, setCurrentPage] = useState(1); // Mevcut sayfa
  const [itemsPerPage] = useState(10); // Sayfa başına kayıt
  const [patientAppointments, setPatientAppointments] = useState([]); // Seçili hasta randevuları
  const [patientPayments, setPatientPayments] = useState([]); // Seçili hasta ödemeleri
  const [patientLabOrders, setPatientLabOrders] = useState([]); // Seçili hasta laboratuvar işleri
  const [loadingAppointments, setLoadingAppointments] = useState(false); // Randevu yüklenme durumu
  const [newPatient, setNewPatient] = useState({
    username: '',
    password: '',
    full_name: '',
    phone: '',
    email: '',
    medical_history: '',
    birth_date: '',
    gender: ''
  });
  const [settings, setSettings] = useState({});
  const [expandedRowId, setExpandedRowId] = useState(null);

  useEffect(() => {
    fetchPatients();
    // Ayarları çek (PDF başlığı için)
    axios.get('./backend/get_settings.php')
      .then(res => {
        if (res.data) setSettings(res.data);
      })
      .catch(err => console.error(err));
  }, []);

  // Arama yapıldığında sayfayı 1'e sıfırla
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const fetchPatients = () => {
    let url = './backend/get_patients.php';
    if (user && user.role === 'doctor') {
        url += `?doctor_id=${user.id}`;
    }
    axios.get(url)
      .then(response => {
        if (Array.isArray(response.data)) {
          setPatients(response.data);
        } else {
          setPatients([]);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Hata:', err);
        toast.error('Veriler yüklenirken bir hata oluştu.');
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    setNewPatient({
      ...newPatient,
      [e.target.name]: e.target.value
    });
  };

  // Yeni Ekleme Modunu Aç
  const openAddModal = () => {
    setNewPatient({ username: '', password: '', full_name: '', phone: '', email: '', medical_history: '', birth_date: '', gender: '' });
    setIsEditing(false);
    setShowModal(true);
  };

  // Düzenleme Modunu Aç
  const openEditModal = (patient) => {
    setNewPatient({
      username: patient.username,
      password: '', // Şifre düzenlemede boş gelir, istenirse girilir
      full_name: patient.full_name,
      phone: patient.phone || '',
      email: patient.email || '',
      medical_history: patient.medical_history || '',
      birth_date: patient.birth_date || '',
      gender: patient.gender || ''
    });
    setCurrentId(patient.id);
    setIsEditing(true);
    setShowModal(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isEditing) {
      // GÜNCELLEME İŞLEMİ
      const updateData = {
        id: currentId,
        full_name: newPatient.full_name,
        phone: newPatient.phone,
        email: newPatient.email,
        medical_history: newPatient.medical_history,
        birth_date: newPatient.birth_date,
        gender: newPatient.gender
      };
      axios.post('./backend/update_patient.php', updateData)
        .then(response => {
          toast.success(response.data.message);
          setShowModal(false);
          fetchPatients();
        })
        .catch(error => {
          console.error('Hata:', error);
          toast.error(error.response?.data?.message || 'Güncelleme sırasında hata oluştu.');
        });
    } else {
      // YENİ EKLEME İŞLEMİ
      axios.post('./backend/add_patient_full.php', newPatient)
        .then(response => {
          toast.success(response.data.message);
          setShowModal(false);
          fetchPatients(); // Listeyi yenile
        })
        .catch(error => {
          console.error('Hata Detayı:', error.response || error);
          toast.error(error.response?.data?.message || 'Hasta eklenirken bir hata oluştu.');
        });
    }
  };

  // Silme İşlemi
  const handleDelete = (id) => {
    if (window.confirm("Bu hastayı silmek istediğinize emin misiniz? Bu işlem geri alınamaz.")) {
      axios.post('./backend/delete_patient.php', { id })
        .then(response => {
          toast.success(response.data.message);
          fetchPatients();
        })
        .catch(error => {
          console.error('Hata:', error);
          toast.error(error.response?.data?.message || 'Silme işlemi başarısız.');
        });
    }
  };

  // Doğum günü yaklaşanları kontrol et (7 gün içinde)
  const isBirthdayUpcoming = (birthDateString) => {
    if (!birthDateString) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const birthDate = new Date(birthDateString);
    const nextBirthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
    
    if (nextBirthday < today) {
      nextBirthday.setFullYear(today.getFullYear() + 1);
    }
    
    const diffTime = nextBirthday - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return diffDays >= 0 && diffDays <= 7;
  };

  // Sıralama Fonksiyonu
  const handleSort = () => {
    setSortOrder(prev => prev === 'asc' ? 'desc' : 'asc');
  };

  // Satır Tıklama
  const handleRowClick = (patient) => {
    setSelectedPatient(patient);
    setShowDetailModal(true);
    setLoadingAppointments(true);
    setPatientAppointments([]); // Önceki veriyi temizle
    setPatientPayments([]); // Önceki ödemeleri temizle
    setPatientLabOrders([]); // Önceki lab işlerini temizle

    // Hastanın randevularını çek
    axios.get(`./backend/get_appointments.php?role=patient&user_id=${patient.id}`)
      .then(response => {
        setPatientAppointments(Array.isArray(response.data) ? response.data : []);
        setLoadingAppointments(false);
      })
      .catch(err => {
        console.error('Randevu yükleme hatası:', err);
        setLoadingAppointments(false);
      });

    // Hastanın ödemelerini çek
    axios.get(`./backend/get_payments.php?patient_id=${patient.id}`)
      .then(response => {
        setPatientPayments(Array.isArray(response.data) ? response.data : []);
      })
      .catch(err => {
        console.error('Ödeme yükleme hatası:', err);
      });

    // Hastanın laboratuvar işlerini çek
    axios.get(`./backend/get_lab_orders.php?patient_id=${patient.id}`)
      .then(response => {
        setPatientLabOrders(Array.isArray(response.data) ? response.data : []);
      })
      .catch(err => {
        console.error('Lab işleri yükleme hatası:', err);
      });
  };

  const toggleRow = (id) => {
    if (window.innerWidth <= 768) {
      setExpandedRowId(expandedRowId === id ? null : id);
    } else {
      // Desktop behavior (optional)
    }
  };

  const handlePrintLabOrders = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
        <html>
        <head>
            <title>Laboratuvar İşleri - ${selectedPatient.full_name}</title>
            <style>
                body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 20px; color: #333; }
                .header { text-align: center; border-bottom: 2px solid #4e73df; padding-bottom: 10px; margin-bottom: 20px; }
                .header h1 { margin: 0; color: #4e73df; font-size: 24px; }
                .header p { margin: 5px 0; color: #666; font-size: 14px; }
                table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                th, td { border: 1px solid #ddd; padding: 8px; text-align: left; font-size: 12px; }
                th { background-color: #f8f9fc; color: #4e73df; }
                .footer { margin-top: 30px; font-size: 10px; color: #999; text-align: center; border-top: 1px solid #eee; padding-top: 10px; }
            </style>
        </head>
        <body>
            <div class="header">
                ${settings.clinic_logo ? `<img src="${settings.clinic_logo}" alt="Logo" style="max-width: ${settings.clinic_logo_width || '150px'}; max-height: 80px; margin-bottom: 5px;">` : ''}
                <h1>${settings.clinic_name || 'Diş Kliniği'}</h1>
                <p>${settings.clinic_address || ''}</p>
                <p>${settings.clinic_phone ? 'Tel: ' + settings.clinic_phone : ''}</p>
            </div>
            
            <h3>Laboratuvar İşleri: ${selectedPatient.full_name}</h3>
            
            <table>
                <thead>
                    <tr>
                        <th>Tarih</th>
                        <th>Laboratuvar</th>
                        <th>İşlem</th>
                        <th>Diş No / Renk</th>
                        <th>Durum</th>
                        <th>Ücret</th>
                    </tr>
                </thead>
                <tbody>
                    ${patientLabOrders.map(order => `
                        <tr>
                            <td>${new Date(order.sent_date).toLocaleDateString()}</td>
                            <td>${order.lab_name}</td>
                            <td>${order.work_type}</td>
                            <td>${order.tooth_number || '-'} / ${order.color_code || '-'}</td>
                            <td>${order.status === 'sent' ? 'Gönderildi' : (order.status === 'in_progress' ? 'İşlemde' : (order.status === 'received' ? 'Geldi' : 'Teslim Edildi'))}</td>
                            <td>${parseFloat(order.price || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</td>
                        </tr>
                    `).join('')}
                </tbody>
            </table>

            <div class="footer">
                Bu belge elektronik ortamda oluşturulmuştur.
            </div>
            <script>window.onload = function() { window.print(); }</script>
        </body>
        </html>
    `);
    printWindow.document.close();
  };

  const handleExport = () => {
    const BOM = "\uFEFF";
    const headers = ["ID", "Ad Soyad", "Kullanıcı Adı", "Telefon", "Email", "Cinsiyet", "Doğum Tarihi", "Kayıt Tarihi"];
    const csvContent = headers.join(";") + "\n" + filteredPatients.map(p => {
        return [
            p.id,
            `"${p.full_name}"`,
            `"${p.username}"`,
            `"${p.phone || ''}"`,
            `"${p.email || ''}"`,
            p.gender === 'male' ? 'Erkek' : (p.gender === 'female' ? 'Kadın' : 'Diğer'),
            p.birth_date ? new Date(p.birth_date).toLocaleDateString() : '-',
            new Date(p.created_at).toLocaleDateString()
        ].join(";");
    }).join("\n");

    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "hasta_listesi.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Arama ve Sıralama Filtreleme
  const filteredPatients = patients.filter(patient =>
    patient.full_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (patient.phone && patient.phone.includes(searchTerm)) ||
    patient.username.toLowerCase().includes(searchTerm.toLowerCase())
  ).sort((a, b) => {
    const nameA = a.full_name.toLowerCase();
    const nameB = b.full_name.toLowerCase();
    return sortOrder === 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
  });

  // Sayfalama Mantığı
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPatients = filteredPatients.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredPatients.length / itemsPerPage);

  if (loading) return <div>Yükleniyor...</div>;
  if (error) return <div>Hata: {error}</div>;

  return (
    <div className="patients-container">
      <div className="header-actions">
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <h2>Hasta Listesi</h2>
          <input type="text" placeholder="Hasta Ara (İsim, Tel)..." className="search-input" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        </div>
        <button className="add-btn" onClick={handleExport} style={{ background: 'linear-gradient(135deg, #f6c23e 0%, #dda20a 100%)', boxShadow: '0 4px 15px rgba(246, 194, 62, 0.4)', marginRight: '10px' }}>Excel'e Aktar</button>
        <button className="add-btn" onClick={openAddModal}>+ Yeni Hasta Ekle</button>
      </div>

      <table className="data-table accordion-table">
        <thead>
          <tr>
            <th>ID</th>
            <th onClick={handleSort} className="sortable-header" title="Sıralamak için tıklayın">
              Ad Soyad {sortOrder === 'asc' ? '▲' : '▼'}
            </th>
            <th>Kullanıcı Adı</th>
            <th>Telefon</th>
            <th>Email</th>
            <th>Cinsiyet</th>
            <th>Doğum Tarihi</th>
            <th>Kayıt Tarihi</th>
            <th>İşlemler</th>
          </tr>
        </thead>
        <tbody>
          {currentPatients.length > 0 ? (
            currentPatients.map(patient => (
              <tr key={patient.id} onClick={() => window.innerWidth <= 768 ? toggleRow(patient.id) : handleRowClick(patient)} className={`clickable-row ${expandedRowId === patient.id ? 'expanded' : ''}`} style={isBirthdayUpcoming(patient.birth_date) ? { backgroundColor: '#fff3cd', borderLeft: '5px solid #f6c23e' } : {}}>
                <td data-label="ID">{patient.id}</td>
                <td data-label="Ad Soyad" className="mobile-visible">{patient.full_name}</td>
                <td data-label="Kullanıcı Adı">{patient.username}</td>
                <td data-label="Telefon" className="mobile-visible">{patient.phone || '-'}</td>
                <td data-label="Email">{patient.email || '-'}</td>
                <td data-label="Cinsiyet">{patient.gender === 'male' ? 'Erkek' : (patient.gender === 'female' ? 'Kadın' : (patient.gender === 'other' ? 'Diğer' : '-'))}</td>
                <td data-label="Doğum Tarihi">{patient.birth_date ? new Date(patient.birth_date).toLocaleDateString() : '-'}</td>
                <td data-label="Kayıt Tarihi">{new Date(patient.created_at).toLocaleDateString()}</td>
                <td data-label="İşlemler">
                  <div className="action-buttons">
                    <button className="edit-btn" style={{ background: '#4e73df' }} onClick={(e) => { e.stopPropagation(); handleRowClick(patient); }}>Detay</button>
                    <button className="edit-btn" onClick={(e) => { e.stopPropagation(); openEditModal(patient); }}>Düzenle</button>
                    <button className="delete-btn" onClick={(e) => { e.stopPropagation(); handleDelete(patient.id); }}>Sil</button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: 'center' }}>
                {searchTerm ? 'Aranan kriterlere uygun hasta bulunamadı.' : 'Kayıtlı hasta bulunamadı.'}
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Sayfalama Kontrolleri */}
      {totalPages > 1 && (
        <div className="pagination">
          <button
            className="page-btn"
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &lt;
          </button>
          <span className="page-info">Sayfa {currentPage} / {totalPages}</span>
          <button
            className="page-btn"
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h3>{isEditing ? 'Hasta Bilgilerini Düzenle' : 'Yeni Hasta Kaydı'}</h3>
              <button className="close-modal-btn" onClick={() => setShowModal(false)}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="white" />
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit} id="patientForm">
                <div className="form-group">
                  <label>Ad Soyad</label>
                  <input type="text" name="full_name" value={newPatient.full_name} onChange={handleChange} required />
                </div>

                {!isEditing && (
                  <>
                    <div className="form-group">
                      <label>Kullanıcı Adı (Giriş için)</label>
                      <input type="text" name="username" value={newPatient.username} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                      <label>Şifre</label>
                      <input type="password" name="password" value={newPatient.password} onChange={handleChange} required />
                    </div>
                  </>
                )}

                <div className="form-group">
                  <label>Telefon</label>
                  <input type="text" name="phone" value={newPatient.phone} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" name="email" value={newPatient.email} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Doğum Tarihi</label>
                  <input type="date" name="birth_date" value={newPatient.birth_date} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Cinsiyet</label>
                  <select name="gender" value={newPatient.gender} onChange={handleChange} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}>
                    <option value="">Seçiniz...</option>
                    <option value="male">Erkek</option>
                    <option value="female">Kadın</option>
                    <option value="other">Diğer</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Anamnez (Tıbbi Geçmiş)</label>
                  <textarea name="medical_history" value={newPatient.medical_history} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '10px', border: '2px solid #eaecf4', minHeight: '80px' }} placeholder="Alerjiler, kronik rahatsızlıklar, kullanılan ilaçlar..." />
                </div>
              </form>
            </div>
            <div className="modal-actions">
              <button type="button" onClick={() => setShowModal(false)} className="cancel-btn">İptal</button>
              <button type="submit" form="patientForm" className="save-btn">{isEditing ? 'Güncelle' : 'Kaydet'}</button>
            </div>
          </div>
        </div>
      )}

      {showDetailModal && selectedPatient && (
        <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Hasta Detayları</h3>
              <button className="close-modal-btn" onClick={() => setShowDetailModal(false)}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="white" />
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <div className="detail-content">
                <div className="detail-row"><span className="detail-label">ID:</span> <span className="detail-value">{selectedPatient.id}</span></div>
                <div className="detail-row"><span className="detail-label">Ad Soyad:</span> <span className="detail-value">{selectedPatient.full_name}</span></div>
                <div className="detail-row"><span className="detail-label">Kullanıcı Adı:</span> <span className="detail-value">{selectedPatient.username}</span></div>
                <div className="detail-row"><span className="detail-label">Telefon:</span> <span className="detail-value">{selectedPatient.phone || '-'}</span></div>
                <div className="detail-row"><span className="detail-label">Email:</span> <span className="detail-value">{selectedPatient.email || '-'}</span></div>
                <div className="detail-row"><span className="detail-label">Doğum Tarihi:</span> <span className="detail-value">{selectedPatient.birth_date ? new Date(selectedPatient.birth_date).toLocaleDateString() : '-'}</span></div>
                <div className="detail-row"><span className="detail-label">Kayıt Tarihi:</span> <span className="detail-value">{new Date(selectedPatient.created_at).toLocaleString()}</span></div>
                <div className="detail-row" style={{ flexDirection: 'column', alignItems: 'flex-start', borderBottom: 'none' }}>
                  <span className="detail-label" style={{ marginBottom: '5px', color: '#e74a3b', fontSize: '0.8rem', display: 'block', width: '100%' }}>⚠ Anamnez (Tıbbi Geçmiş):</span>
                  <div className="detail-value" style={{ background: '#fff5f5', padding: '10px', borderRadius: '8px', width: '100%', border: '1px solid #ffcccc', fontSize: '0.9rem', boxSizing: 'border-box' }}>
                    {selectedPatient.medical_history || 'Kayıtlı tıbbi geçmiş bulunmuyor.'}
                  </div>
                </div>
              </div>

              <h4 style={{ color: '#4e73df', borderBottom: '1px solid #eaecf4', paddingBottom: '10px', marginTop: '20px' }}>Geçmiş Randevular</h4>
            
            {/* Hasta Özeti */}
            {(() => {
                const totalServiceCost = patientAppointments.filter(app => app.status === 'completed').reduce((sum, app) => {
                    return sum + (app.price ? parseFloat(app.price) : (app.treatment_price ? parseFloat(app.treatment_price) : 0));
                }, 0);
                const totalPaid = patientPayments.reduce((sum, pay) => sum + parseFloat(pay.amount), 0);
                const totalLabCost = patientLabOrders.reduce((sum, order) => sum + parseFloat(order.price || 0), 0);
                const balance = (totalServiceCost + totalLabCost) - totalPaid;

                return (
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '15px' }}>
                        <div style={{ background: '#e3f2fd', padding: '10px', borderRadius: '8px', color: '#0d47a1', fontSize: '0.9rem' }}>
                            <strong>Toplam Randevu:</strong> {patientAppointments.length}
                        </div>
                        <div style={{ background: '#e8f5e9', padding: '10px', borderRadius: '8px', color: '#1b5e20', fontSize: '0.9rem' }}>
                            <strong>Hizmet Bedeli:</strong> {totalServiceCost.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                        </div>
                        <div style={{ background: '#f3e5f5', padding: '10px', borderRadius: '8px', color: '#4a148c', fontSize: '0.9rem' }}>
                            <strong>Lab. Masrafı:</strong> {totalLabCost.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                        </div>
                        <div style={{ background: '#fff3cd', padding: '10px', borderRadius: '8px', color: '#856404', fontSize: '0.9rem' }}>
                            <strong>Tahsil Edilen:</strong> {totalPaid.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                        </div>
                        <div style={{ background: balance > 0 ? '#ffebee' : '#e0f2f1', padding: '10px', borderRadius: '8px', color: balance > 0 ? '#c62828' : '#00695c', fontSize: '0.9rem' }}>
                            <strong>{balance > 0 ? 'Kalan Borç:' : 'Bakiye:'}</strong> {Math.abs(balance).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                        </div>
                    </div>
                );
            })()}

              <div className="appointments-list">
                {loadingAppointments ? (
                  <p>Yükleniyor...</p>
                ) : patientAppointments.length > 0 ? (
                  <table className="modal-appointments-table">
                    <thead>
                      <tr>
                        <th>Tarih</th>
                        <th>Doktor</th>
                        <th>Tedavi</th>
                        <th>Durum</th>
                      </tr>
                    </thead>
                    <tbody>
                      {patientAppointments.map(app => (
                        <tr key={app.id}>
                          <td>{new Date(app.appointment_date).toLocaleDateString()}</td>
                          <td>{app.doctor_name}</td>
                          <td>{app.treatment_name || '-'}</td>
                          <td>
                            <span className={`status-badge status-${app.status}`}>
                              {app.status === 'scheduled' ? 'Planlandı' : app.status === 'completed' ? 'Tamamlandı' : 'İptal'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>Kayıtlı randevu bulunamadı.</p>
                )}
              </div>

              <h4 style={{ color: '#1cc88a', borderBottom: '1px solid #eaecf4', paddingBottom: '10px', marginTop: '20px' }}>Ödeme Geçmişi</h4>
              <div className="appointments-list">
                {patientPayments.length > 0 ? (
                  <table className="modal-appointments-table">
                    <thead>
                      <tr>
                        <th>Tarih</th>
                        <th>Tutar</th>
                        <th>Yöntem</th>
                        <th>Açıklama</th>
                      </tr>
                    </thead>
                    <tbody>
                      {patientPayments.map(pay => (
                        <tr key={pay.id}>
                          <td>{new Date(pay.payment_date).toLocaleDateString()}</td>
                          <td style={{fontWeight: 'bold', color: '#1cc88a'}}>{parseFloat(pay.amount).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</td>
                          <td>{pay.payment_method === 'cash' ? 'Nakit' : (pay.payment_method === 'credit_card' ? 'Kredi Kartı' : 'Havale/EFT')}</td>
                          <td>{pay.description}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p style={{ fontSize: '0.9rem', color: '#858796' }}>Kayıtlı ödeme bulunamadı.</p>
                )}
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eaecf4', paddingBottom: '10px', marginTop: '20px' }}>
                <h4 style={{ color: '#4e73df', margin: 0 }}>Laboratuvar İşleri</h4>
                {patientLabOrders.length > 0 && <button onClick={handlePrintLabOrders} className="edit-btn" style={{ fontSize: '0.8rem', padding: '4px 10px' }}>PDF İndir</button>}
              </div>
              <div className="appointments-list">
                {patientLabOrders.length > 0 ? (
                  <table className="modal-appointments-table">
                    <thead>
                      <tr>
                        <th>Tarih</th>
                        <th>Lab & İşlem</th>
                        <th>Diş No / Renk</th>
                        <th>Durum</th>
                        <th>Ücret</th>
                      </tr>
                    </thead>
                    <tbody>
                      {patientLabOrders.map(order => (
                        <tr key={order.id}>
                          <td>{new Date(order.sent_date).toLocaleDateString()}</td>
                          <td>{order.lab_name} - {order.work_type}</td>
                          <td>{order.tooth_number || '-'} / {order.color_code || '-'}</td>
                          <td>
                            {(() => {
                                const styles = {
                                    sent: { bg: '#e3f2fd', color: '#0d47a1', label: 'Gönderildi' },
                                    in_progress: { bg: '#fff3cd', color: '#856404', label: 'İşlemde' },
                                    received: { bg: '#e8f5e9', color: '#1b5e20', label: 'Geldi' },
                                    delivered: { bg: '#d1c4e9', color: '#4a148c', label: 'Teslim Edildi' }
                                };
                                const s = styles[order.status] || styles.sent;
                                return <span style={{ backgroundColor: s.bg, color: s.color, padding: '3px 8px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '600' }}>{s.label}</span>;
                            })()}
                          </td>
                          <td style={{fontWeight: 'bold', color: '#1cc88a'}}>{parseFloat(order.price || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="4" style={{ textAlign: 'right', fontWeight: 'bold', borderTop: '2px solid #eaecf4' }}>Toplam Lab. Masrafı:</td>
                            <td style={{ fontWeight: 'bold', color: '#4a148c', borderTop: '2px solid #eaecf4' }}>
                                {patientLabOrders.reduce((sum, order) => sum + parseFloat(order.price || 0), 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                            </td>
                        </tr>
                    </tfoot>
                  </table>
                ) : (
                  <p style={{ fontSize: '0.9rem', color: '#858796' }}>Kayıtlı laboratuvar işi bulunamadı.</p>
                )}
              </div>
            </div>
            <div className="modal-actions">
              <button className="save-btn" onClick={() => setShowDetailModal(false)}>Kapat</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Patients;